// 导出一个axios的实例，而且这个实例要有请求拦截器 响应拦截器
import axios from 'axios'
import { Message } from 'element-ui'
import { baseURL } from '@/api/config'
const service = axios.create({
  baseURL: baseURL, // 设置axios请求的基础的基础地址
  timeout: 50000 // 定义5秒超时
}
) // 创建一个axios的实例
service.interceptors.request.use(config => {
  config.headers.Authorization = 'JWT ' + window.sessionStorage.getItem('token')
  return config
}, error => {
  return Promise.reject(error)
}) // 请求拦截器
service.interceptors.response.use(response => {
  const { status, data } = response
  if (status === 200 || status === 204 || status === 201) {
    return data
  } else if (status === 401 || status === 403) {
    window.sessionStorage.clear()
    this.$router.push('/login')
  } else {
    const message = '异常'
    Message.error(message)
    return Promise.reject(new Error(message))
  }
}, error => {
  const status = error.response.status
  if (status === 401 || status === 403) {
    window.sessionStorage.clear()
    this.$router.push('/login')
  }
  var str = error.message + '\r\n'
  var data = error.response.data
  var keys = Object.keys(data)
  for (var i = 0; i < keys.length; i++) {
    console.log(keys[i] + ':' + data[keys[i]])
    str += keys[i] + ':' + data[keys[i]] + '\r\n'
  }
  console.log(str)
  Message.error(str)
  return Promise.reject(error)
}) // 响应拦截器
export default service // 导出axios实例
